export default __webpack_public_path__ + "static/media/blockie.da287690.png";